// src/components/Training/TrainingForm.jsx

import { useState, useEffect } from 'react';
import API from '../../api/axiosConfig';

const TRAINING_TYPES = [
  { value: 1, label: 'داخلي',     icon: '🏢' },
  { value: 2, label: 'خارجي',     icon: '🌐' },
  { value: 3, label: 'إلكتروني',  icon: '💻' },
];

const TrainingForm = ({ period, onSuccess, initialData = null }) => {
  const [employees, setEmployees] = useState([]);
  const [form, setForm] = useState({
    employee_id:   initialData?.employee_id   ?? '',
    title:         initialData?.title         ?? '',
    description:   initialData?.description   ?? '',
    hours:         initialData?.hours         ?? '',
    training_date: initialData?.training_date ?? '',
    period:        period,
    type:          initialData?.type          ?? 1,
    certificate:   initialData?.certificate   ?? '',
  });
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  // جيب الموظفين
  useEffect(() => {
    API.post('/employees').then(res => {
      setEmployees(res.data?.data ?? res.data ?? []);
    }).catch(() => {});
  }, []);

  // أضف هذا الـ useEffect بعد useEffect الموظفين
useEffect(() => {
  setForm(f => ({ ...f, period }));
}, [period]);

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    try {
      if (initialData) {
        await API.put(`/training-records/${initialData.id}`, form);
      } else {
        await API.post('/training-records', form);
      }
      onSuccess?.();
    } catch (e) {
      setError(e.response?.data?.message ?? 'حدث خطأ');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rounded-2xl p-6 shadow-sm border border-gray-100" dir="rtl" style={{ backgroundColor: '--var(--background-color)' , width: '80%' , margin: '10px auto' , padding: '20px' }}>
      <h3 className="text-lg font-semibold text-gray-800 mb-6" style={{ textAlign: 'center' }}>
        {initialData ? 'تعديل سجل التدريب' : 'إضافة سجل تدريب'}
      </h3>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 text-sm
                        rounded-xl p-3 mb-4">
          {error}
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">

        {/* الموظف */}
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            الموظف <span className="text-red-500">*</span>
          </label>
          <select
            value={form.employee_id}
            onChange={e => set('employee_id', e.target.value)}
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                       text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                       style={{width:"100%" , border:"1px solid --var(background-color)" , borderRadius:"2px" , margin:"3px"}}
          >
            <option value="">اختر الموظف</option>
            {employees.map(emp => (
              <option key={emp.id} value={emp.id}>{emp.name}</option>
            ))}
          </select>
        </div>

        {/* عنوان التدريب */}
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            عنوان التدريب <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={form.title}
            onChange={e => set('title', e.target.value)}
            placeholder="مثال: دورة إدارة المشاريع"
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                       text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                       style={{width:"100%" , border:"1px solid --var(background-color)" , borderRadius:"2px" , margin:"3px"}}
          />
        </div>

        {/* عدد الساعات */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            عدد الساعات <span className="text-red-500">*</span>
          </label>
          <input
            type="number"
            min="0.5"
            step="0.5"
            value={form.hours}
            onChange={e => set('hours', e.target.value)}
            placeholder="مثال: 16"
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                       text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                       style={{width:"100%" , border:"1px solid --var(background-color)" , borderRadius:"2px" , margin:"3px"}}
          />
        </div>

        {/* تاريخ التدريب */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            تاريخ التدريب <span className="text-red-500">*</span>
          </label>
          <input
            type="date"
            value={form.training_date}
            onChange={e => set('training_date', e.target.value)}
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                       text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                       style={{width:"100%" , border:"1px solid --var(background-color)" , borderRadius:"2px" , margin:"3px"}}
          />
        </div>

        {/* نوع التدريب */}
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            نوع التدريب <span className="text-red-500">*</span>
          </label>
          <div className="flex gap-3" style={{display:"flex" , justifyContent:"center" , gap:"10px"}}>
            {TRAINING_TYPES.map(t => (
              <button
                key={t.value}
                onClick={() => set('type', t.value)}
                className={`flex-1 flex flex-col items-center gap-1 py-3 rounded-xl
                            border-2 transition-all text-sm
                            ${form.type === t.value
                              ? 'border-blue-500 bg-blue-50 text-blue-700'
                              : 'border-gray-200 text-gray-600 hover:border-gray-300'}`}
                               style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px',
    padding: '10px',
    borderRadius: '12px',
    border: form.type === t.value
      ? '2px solid #3b82f6'
      : '2px solid #e5e7eb',
    backgroundColor: form.type === t.value ? '#eff6ff' : '#fff',
    width: '150px',
    cursor: 'pointer',
    transition: 'all 0.2s',
  }}
              >
                <span className="text-xl">{t.icon}</span>
                <span>{t.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* الوصف */}
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            الوصف (اختياري)
          </label>
          <textarea
            value={form.description}
            onChange={e => set('description', e.target.value)}
            placeholder="تفاصيل إضافية عن الدورة..."
            rows={3}
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                       text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500
                       resize-none"
                        style={{width:"100%" , border:"1px solid --var(background-color)" , borderRadius:"2px" , margin:"3px"}}
          />
        </div>

        {/* الشهادة */}
        <div className="sm:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            رقم / اسم الشهادة (اختياري)
          </label>
          <input
            type="text"
            value={form.certificate}
            onChange={e => set('certificate', e.target.value)}
            placeholder="مثال: PMP-2025-001"
            className="w-full border border-gray-300 rounded-xl px-4 py-2.5 text-sm
                       text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        style={{width:"100%" , border:"1px solid --var(background-color)" , borderRadius:"2px" , margin:"3px"}}
          />
        </div>
      </div>

      <button
        onClick={handleSubmit}
        disabled={loading}
        className="w-full mt-6 bg-teal-600 text-white py-3 rounded-xl font-medium
                   hover:bg-teal-700 disabled:opacity-50 transition-colors"
        style={{ backgroundColor: '--var(--background-color)' , color: '--var(--text-color)' , border: '3px solid var(--border-color)' , borderRadius: '18px' , margin:"10px 200px" }}
      >
        {loading ? 'جاري الحفظ...' : initialData ? 'حفظ التعديلات' : 'إضافة سجل التدريب'}
      </button>
    </div>
  );
};

export default TrainingForm;